import { Component } from "react";
import { Switch, Route } from "react-router-dom";
import { initGA4 } from "./utils/GoogleAnalytics";

//COMPOSANTS
import Header from "./components/header";
import Footer from "./components/footer";
import Modal from "./components/modal";

//PAGES
import Index from "./pages/index";
import Sh from "./pages/sh";
import Scian from "./pages/scian";
import Remerciements from "./pages/remerciements";
import Renseignements from "./pages/renseignements";
import Definitions from "./pages/definitions";

//Contenu modal
import { modalContents } from "./modal-contents";

//util
import dateUtil from "./utils/dateUtil";
import HTMLUtil from "./utils/htmlUtil";
import moment from "moment";

//CONSTANTES
const PREFIX_API = HTMLUtil.getPrefixAPI();

/** Date de la prochaine mise à jour du CIEL **/
const DATE_REF = moment("2026-07-21", "YYYY-MM-DD", true);
/***/

class App extends Component {
  constructor(props) {
    super(props);

    this._fetchLatestDate = this._fetchLatestDate.bind(this);
    this._toggleLangHandler = this._toggleLangHandler.bind(this);
    this._showModalHandler = this._showModalHandler.bind(this);

    //routes et component selon la langue
    this.routes = {
      index: Index,
      "sh-hs": Sh,
      "scian-naics": Scian,
      "renseignements-information": Renseignements,
      "remerciements-acknowledgments": Remerciements,
      definitions: Definitions,
    };

    //Initialiser avec la langue du document et la page affichée par défaut
    this.state = {
      lang: this._initLang(),
      latestDataUpdate: "",
      page: "index",
      modal: {
        id: "modal-window",
        title: "",
        content: "",
        printable: false,
      },
    };
  }

  render() {
    // Date contextuelle à utiliser comme référence pour afficher les infos de mise à jour du calendrier de diffusion

    const isProd = window.location.href.includes("statistique.quebec.ca");

    // Date du client à considérer selon l'environnement
    // 1. Production: Date réel du client/utilisateur
    // 2. Validation: Date de référence à la prochaine mise à jour
    const curDate =
      isProd || moment().isSameOrAfter(DATE_REF) ? moment() : DATE_REF;

    let formattedLatestDate = dateUtil.dateToString(
      this.state.latestDataUpdate,
      this.state.lang,
    );

    // Dernière mise à jour ISQ
    const latestUpdateISQ = dateUtil.getLatestDateFromCalendarSince(
      "ISQ",
      curDate,
    );
    // Dernière mise à jour StatCan depuis la dernière mise à jour ISQ
    const latestUpdateStatCan = dateUtil.getLatestDateFromCalendarSince(
      "STATCAN",
      latestUpdateISQ,
    );
    let pageProps = {
      curDate,
      lang: this.state.lang,
      showModal: this._showModalHandler,
      latestDataUpdate: formattedLatestDate,
      latestUpdateISQ,
      latestUpdateStatCan,
    };

    return (
      <div className="app">
        <Modal id="modal-window" lang={this.state.lang} />
        <Header lang={this.state.lang} toggleLang={this._toggleLangHandler} />
        <Switch>
          <Route
            path="/:page"
            render={(props) => {
              let pageParam = props.match.params.page;
              let Page = this.routes[pageParam] || this.routes["index"];
              return <Page {...pageProps} {...props} />;
            }}
          />

          <Route
            path="/"
            render={(props) => {
              return <Index {...pageProps} {...props} />;
            }}
          />
        </Switch>
        <Footer lang={this.state.lang} />
      </div>
    );
  }

  componentDidMount() {
    this._fetchLatestDate();
    initGA4();
  }

  _initLang() {
    let lang =
      window.location.href.indexOf("international-trade") > -1 ? "en" : "fr";

    //init titre et langue de la page
    document.querySelector("html").lang = lang;
    document.querySelector("title").innerHTML =
      lang === "en"
        ? "International Trade Data Online"
        : "Commerce international en ligne";

    return lang;
  }
  /**
   * Au switch de langue anglais/francais, rediriger vers l'url adéquate avec le "hash" traduit
   */
  _toggleLangHandler() {
    let newUrl = `${window.location.protocol}//${window.location.host}/${
      this.state.lang === "fr"
        ? "international-trade"
        : "commerce-international"
    }/${window.location.hash}`;
    document.location.href = newUrl;
  }

  _getCurrentModalContent() {
    let modalContent;
    if (modalContents[this.state.modal.content]) {
      modalContent = modalContents[this.state.modal.content][this.state.lang]();
    } else {
      modalContent = (
        <h5>{this.state.lang === "fr" ? "Non disponible" : "Not available"}</h5>
      );
    }

    return modalContent;
  }

  _showModalHandler(title, content) {
    this.setState(
      (prevState) => {
        let modalState = Object.assign({}, prevState.modal, { title, content });
        return { modal: modalState };
      },
      () => {
        window.$(`#${this.state.modal.id}`).modal("show");
      },
    );
  }

  _updateState(field, val) {
    this.setState((prevState) => {
      return { [field]: val };
    });
  }

  _fetchLatestDate() {
    //Récupérer la date des données la plus récente
    fetch(`${PREFIX_API}hkc_api_web.p_retrn_date`)
      .then((resp) => {
        if (resp.status >= 200 && resp.status < 400) {
          return resp.text();
        } else {
          return "";
        }
      })
      .then((data) => {
        this._updateState("latestDataUpdate", data);
      })
      .catch((error) => {
        console.error("Problèmes: getLatestDate", error);

        this._updateState("latestDataUpdate", "");
      });
  }
}

export default App;
